import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ComboBox, InputWithLabel, Modal } from '@reveni-io/reveni-ui'

import useAvailableTransactionTypesForRegion from '@/hooks/useAvailableTransactionTypesForRegion/useAvailableTransactionTypesForRegion'
import useTransactionTypes from '@/hooks/useTransactionTypes/useTransactionTypes'

import * as Styles from './styles'

const RegionsModal = ({
  show,
  provinces = [],
  selectedCountry,
  selectedProvince,
  onAccept,
  onClose,
  availableTransactionTypes,
  availableTransactionTypesForRegion,
  allowsUnifiedFlow,
}) => {
  const { t } = useTranslation()
  const [province, setProvince] = useState(selectedProvince || '')
  const { getOrderTransactionType } = useTransactionTypes()
  const { transactionsNotAllowed, getTransactionsNotAllowedText } = useAvailableTransactionTypesForRegion({
    availableTransactionTypes,
    availableTransactionTypesForRegion,
    allowsUnifiedFlow,
  })

  const handleClick = () => {
    onAccept(province)
  }

  const handleCloseModal = () => {
    if (selectedProvince) {
      onClose()
    }
  }

  return (
    <Modal show={show} onClose={handleCloseModal} title={t('Región')} size="m">
      <Styles.Container>
        <p>
          {transactionsNotAllowed.includes(getOrderTransactionType())
            ? t(
                'La política de devoluciones no permite {{transactionTypes}} de productos desde tu región. Por favor selecciona una región distinta desde la que enviar tus productos para continuar',
                { transactionTypes: getTransactionsNotAllowedText() }
              )
            : t(
                'Selecciona la región desde la que devolverás los productos y así mostrar los métodos de devolución disponibles y su coste asociado'
              )}
          :
        </p>
        <InputWithLabel label={t('País')} value={selectedCountry} fullWidth disabled />
        {provinces.length > 0 && (
          <ComboBox
            label={t('Provincia')}
            value={province}
            menuItems={provinces}
            handleChange={e => setProvince(e.target.value)}
            fullWidth
          />
        )}
        <Styles.ActionsContainer>
          {(selectedProvince || province) && (
            <Button onClick={handleCloseModal} variant="outlined">
              {t('Cancelar')}
            </Button>
          )}
          <Button onClick={handleClick} disabled={!province}>
            {t('Seleccionar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default RegionsModal
